import React, { useState, useEffect } from 'react';
import { checkSetupRequired, setupAdmin, loginUser } from '../services/apiService';
import '../styles/AuthPage.css';
import logo from '../resources/BSG_Traders.png';

const AuthPage = ({ onAuth }) => {
  const [mode, setMode] = useState(null); // null = loading, 'setup' | 'login'
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    checkSetupRequired()
      .then(data => setMode(data.setupRequired ? 'setup' : 'login'))
      .catch(() => setMode('login'));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username.trim() || !password) {
      setError('Username and password are required.');
      return;
    }

    if (mode === 'setup') {
      if (password.length < 6) {
        setError('Password must be at least 6 characters.');
        return;
      }
      if (password !== confirm) {
        setError('Passwords do not match.');
        return;
      }
    }

    setLoading(true);
    try {
      let user;
      if (mode === 'setup') {
        user = await setupAdmin(username.trim(), password);
      } else {
        user = await loginUser(username.trim(), password);
      }
      onAuth(user);
    } catch (err) {
      const msg = err?.response?.data?.error;
      setError(msg || (mode === 'setup' ? 'Setup failed.' : 'Invalid username or password.'));
    } finally {
      setLoading(false);
    }
  };

  if (mode === null) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <img src={logo} alt="BSG Traders" className="auth-logo" />
          <p className="auth-loading">Connecting…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <img src={logo} alt="BSG Traders" className="auth-logo" />
        <h1 className="auth-title">BSG Traders</h1>

        {mode === 'setup' ? (
          <div className="auth-setup-badge">First Launch — Create Admin Account</div>
        ) : (
          <p className="auth-subtitle">Sign in to continue</p>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}

          <div className="auth-field">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
              disabled={loading}
            />
          </div>

          <div className="auth-field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete={mode === 'setup' ? 'new-password' : 'current-password'}
              disabled={loading}
            />
          </div>

          {mode === 'setup' && (
            <div className="auth-field">
              <label>Confirm Password</label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                autoComplete="new-password"
                disabled={loading}
              />
            </div>
          )}

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading
              ? (mode === 'setup' ? 'Creating…' : 'Signing in…')
              : (mode === 'setup' ? 'Create Admin Account' : 'Sign In')}
          </button>
        </form>

        {mode === 'setup' && (
          <p className="auth-hint">
            This is a one-time setup. After this, only admins can create new users.
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthPage;
